module.exports =  {

  whatIsLedgerDex: {
    title: "什么是LedgerDex?",
    contents: `
    <p>LedgerDex是新一代的加密代币(Token)管理平台和去中心化交易所。用户可以使用LedgerDex来管理和交易基于以太坊的(ERC20)代币。</p>
    <p>使用LedgerDex的<strong>代币管理平台</strong>，用户可以查看个人代币资产的余额、发送和接收ERC20代币。</p>
    <p>作为一家基于<a href="https://0xproject.com/" target="_blank" rel="nofollow"><strong>0x协议</strong></a>的<strong>去中心化交易所</strong>， LedgerDex支持用户间点对点的安全代币交易。</p>
    `,
  },

  howDoesTradeWork: {
    title: "在LedgerDex平台上交易是如何完成的?",
    contents: `
      <p>LedgerDex是建立在<a href="https://0xproject.com/" target="_blank" rel="nofollow"><strong>0x 协议</a></strong>上的去中心化交易所，0x协议是“一个无需许可的开源协议，用于促进以太坊区块链中ERC20代币的交易”。</p>
      <p>所有交易都是通过部署在以太坊区块链上的0x智能合约来完成的。用户不需要向交易所或向智能合约打钱或打币，交易涉及的代币在交易双方的数字钱包之间直接完成交换。</p>
      <p>为降低交易费用并提高交易效率，新产生的交易订单并不在区块链上存储（因此可以节省矿工费Gas），只有交易结算步骤在链上进行。</p>
    `,
  },

  whatMakeUniqueAsExchange: {
    title: "作为一家交易所，LedgerDex有哪些特别之处？",
    contents: `
    <p>LedgerDex是一家去中心化交易所，支持用户钱包之间直接的点对点交易。LedgerDex具有以下特点：</p>
      <p><strong>容易上手，简单易用：</strong></p>
      <ul class="mb-2">
        <li>不需要注册，直接使用以太坊账号。</li>
        <li>不需要暴露个人信息。</li>
        <li>直接使用浏览器钱包插件MetaMask登录和交易。</li>
      </ul>
      <p><strong>安全：</strong></p>
      <ul class="mb-2">
        <li>不需要给交易所打钱或打币。</li>
        <li>交易时，代币在交易双方的数字钱包之间直接完成交换。</li>
        <li>不需要担心交易所被黑或卷钱跑路。</li>
      </ul>
      <p><strong>可靠：</strong></p>
      <ul class="mb-2">
        <li>基于0x协议，这是业内最著名、最受认可的去中心化交易协议。</li>
        <li>交易通过0x的智能合约完成，避免了交易所黑箱操作的可能。</li>
      </ul>
    `,
  },

  howDifferentFromOtherERC20Exchanges: {
    title: "和其它代币交易所相比，LedgerDex有哪些特别之处？",
    contents: `
      <p>LedgerDex不同于中心化交易所（如 Coinbase、Kraken），因为我们不经手用户的资金，您不需要给我们打钱或打币，所以不需要担心自己的资金被黑或被盗。另外，所有交易通过0x的智能合约完成，整个过程公开透明，您不需要担心交易所存在任何黑箱操作。</p>
      <p>LedgerDex也与其它去中心化交易所存在一些不同之处：1) 与一些其它去中心化交易所不同，LedgerDex的订单并不存储在以太坊的区块链上，这样用户下单时就节省了一笔矿工费(Gas)。 2) 绝大多数基于0x协议的去中心化交易所只可以交易有限的若干种代币，而LedgerDex<strong>支持用户自助免费上币</strong>。</p>
    `,
  },

  howToGetStarted: {
    title: "如何开始使用LedgerDex?",
    contents: `
      <p>以下是一些使用LedgerDex的基本要求：</p>
      <ul class="mb-2">
        <li><strong>以太坊账号</strong>：您可以通过以太坊的软件或硬件钱包来获得以太坊账号。请注意账号安全，妥善保管和备份账号私钥。
        </li>
        <li><strong>电脑浏览器插件MetaMask或支持dApp浏览器的移动端钱包</strong>: 若要在电脑上使用LedgerDex，您需要使用浏览器插件钱包<a href="https://metamask.io/" target="_blank" rel="nofollow">MetaMask</a>来登录账户、完成交易。若要在移动端（如手机）使用LedgerDex，您需要使用带有dApp浏览器功能的加密货币钱包APP（如imToken）。</li>
        <li><strong>将以太币ETH包装成WETH</strong>：因为历史原因，以太币(ETH) 本身并不符合ERC20代币的标准，因此不能直接和其它ERC20代币交易。目前的解决办法是把ETH兑换成与之等值的ERC20代币WETH，使用WETH交易。WETH和ETH永远是1:1的兑换率，您可以随时在LedgerDex把ETH兑换成WETH（这一步骤叫做“包装ETH”或“Wrap”）或者把WETH兑换成ETH（这一步骤叫做“卸装WETH”或“Unwrap”)。</li>
        <li><strong>添加代币的交易授权</strong>：为保证智能合约能够完成您的交易，您需要授予智能合约为您的账户进行交易的权力委托。这一过程叫做“交易授权”或“Allowance”。您可以随时添加或取消授权。对于每一种您需要卖出的代币您都需要事先单独添加交易授权。</li>
      </ul>
    `,
  },

  whatCanBeDoneWithLedgerDex: {
    title: "LedgerDex有哪些用途？",
    contents: `
      <p>以下是一些LedgerDex的应用场景：</p>
      <ul class="mb-2">
        <li><strong>管理个人代币资产</strong>：您可能拥有很多不同的ERC20代币，以至于管理不过来。这时候您可以使用LedgerDex来统一管理这些代币。在“我的代币”页面，您可以一览无余地查看各种代币的余额，并且可以发送或接收代币。</li>
        <li><strong>通过买卖代币获利</strong>：LedgerDex是一家去中心化交易所。在这里您可以进行代币交易并有希望从中获利。</li>
        <li><strong>点对点代币交换</strong>：在LedgerDex下交易订单时，您可以指定交易对象（仅允许您指定的账号吃单），这一功能很适合双方直接交换不同代币，因为LedgerDex起到了中间人作用，能够保证交易双方“一手交钱、一手交货”，让整个过程安全、可靠。</li>
        <li><strong>出售或购买其它交易所不支持的代币</strong>：LedgerDex支持免费自助上币，用户可以自己添加交易币种。因此您可以在LedgerDex交易没有在其它交易所上币的以太坊代币。</li>
      </ul>
    `,
  },

  limitations: {
    title: "LedgerDex有哪些局限性？",
    contents: `
      <p>LedgerDex目前仅支持基于以太坊的ERC20代币，所以，您还不能在这里管理或交易如比特币、莱特币、瑞波币等其它币种。</p>
      <p>因为所有代币交易都是通过部署在以太坊区块链上的智能合约完成的，所以交易速度受到以太坊网络速度的限制，比起中心化交易所来，交易速度会相对慢一些。
      </p>
    `,
  },

}


